function AnimatingHead() {
  return (
    <svg
      className="w-[72px] h-[72px]"
      xmlns="http://www.w3.org/2000/svg"
      //   xmlns:xlink="http://www.w3.org/1999/xlink"
      id="animation"
      version="1.1"
      viewBox="0 0 72 72"
    >
      <defs>
        <filter id="blur" width="125%" height="125%" x="-12.5%" y="-12.5%">
          <feGaussianBlur in="SourceGraphic" stdDeviation="6" />
        </filter>
        <mask id="color_mask">
          <path d="M0 0 h72 v72 H0z" />
          <path
            id="gear"
            fill="none"
            stroke="#fff"
            stroke-width="1.7"
            d="M 52.0988,25.7864 L 50.6114,29.4473 L 46.8184,28.8571 C 45.3671,30.8583 43.4908,32.8499 41.6765,34.0177 L 42.434,37.6113 L 38.8886,39.2145 L 36.6305,36.1185 V 36.1185 C 35.453,36.3883 34.227,36.5309 32.9677,36.5309 C 31.7431,36.5309 30.5499,36.3961 29.4023,36.1405 L 27.3408,39.3388 L 23.6799,37.8514 L 24.2701,34.0584 C 22.2689,32.6071 20.2773,30.7308 19.1095,28.9165 L 15.5452,29.7105 L 13.942,26.1651 L 17.038,23.907 V 23.907 C 16.7682,22.7295 16.6257,21.5035 16.6257,20.2442 C 16.6257,19.0196 16.7605,17.8264 17.016,16.6788 L 13.8366,14.6113 L 15.324,10.9504 L 19.117,11.5406 C 20.5683,9.53937 22.4446,7.54777 24.2589,6.37997 L 23.5014,2.7864 L 27.0468,1.18318 L 29.3049,4.27918 V 4.27918 C 30.4824,4.00938 31.7084,3.86685 32.9677,3.86685 C 34.1923,3.86685 35.3855,4.00164 36.5331,4.25719 L 38.5946,1.05889 L 42.2555,2.54629 L 41.6653,6.33929 C 43.6665,7.79059 45.6581,9.66689 46.8259,11.4812 L 50.4195,10.7237 L 52.0227,14.2691 L 48.9267,16.5272 V 16.5272 C 49.1965,17.7047 49.339,18.9307 49.339,20.19 C 49.339,21.4146 49.2042,22.6078 48.9634,23.7737 Z M 43.5488,20.1988 A 10.5811,10.5811 0 0 1 32.9677,30.7799 A 10.5811,10.5811 0 0 1 22.3866,20.1988 A 10.5811,10.5811 0 0 1 32.9677,9.61781 A 10.5811,10.5811 0 0 1 43.5488,20.1988 Z"
          />
          <g id="face">
            <path
              id="face_outline"
              stroke="#fff"
              stroke-width="1.7"
              d="M 20.4688,72 V 65.7414 C 21.0688,50.8908 2.91079,42.542 10.2973,22.0605 M 56.215,22.2373 C 57.5702,24.5484 57.0409,28.155 57.1873,31.2971 L 62.8884,44.2902 L 58.0712,44.4007 L 58.4375,53.0312 C 58.5426,55.5068 56.5932,56.8437 55.0625,56.8437 H 47.5088 V 70.9687 H 42.375"
            />
            <path
              id="dots"
              fill="#fff"
              stroke-width="1.7"
              d="M 42.125,59.4531 V 61.2539 H 43.9258 V 59.4531 Z M 42.125,63.3906 V 65.1914 H 43.9258 V 63.3906 Z"
            />
          </g>
        </mask>
      </defs>
      <g mask="url(#color_mask)">
        <circle fill="#1A458D" cx="32.968" cy="20.2" r="55"></circle>
        <g transform="translate(32.968 20.2)">
          <g id="c_1" filter="url(#blur)" transform="scale(0 0)">
            <g transform="translate(-32.968 -20.2)">
              <circle fill="#1A458D" cx="32.968" cy="20.2" r="55"></circle>
            </g>
          </g>
        </g>
        <g transform="translate(32.968 20.2)">
          <g id="c_2" filter="url(#blur)" transform="scale(0 0)">
            <g transform="translate(-32.968 -20.2)">
              <circle fill="#289B5E" cx="32.968" cy="20.2" r="55"></circle>
            </g>
          </g>
        </g>
        <g transform="translate(32.968 20.2)">
          <g id="c_3" filter="url(#blur)" transform="scale(0 0)">
            <g transform="translate(-32.968 -20.2)">
              <circle fill="#C1A10E" cx="32.968" cy="20.2" r="55"></circle>
            </g>
          </g>
        </g>
        <g transform="translate(32.968 20.2)">
          <g id="c_4" filter="url(#blur)" transform="scale(0 0)">
            <g transform="translate(-32.968 -20.2)">
              <circle fill="#FE5A2D" cx="32.968" cy="20.2" r="55"></circle>
            </g>
          </g>
        </g>
        <g transform="translate(32.968 20.2)">
          <g id="c_5" filter="url(#blur)" transform="scale(0 0)">
            <g transform="translate(-32.968 -20.2)">
              <circle fill="#1A458D" cx="32.968" cy="20.2" r="55"></circle>
            </g>
          </g>
        </g>
      </g>
      <animateTransform
        id="init"
        attributeType="XML"
        attributeName="transform"
        type="rotate"
        xlinkHref="#gear"
        values="0 32.968 20.2; 360 32.968 20.2"
        begin="0s"
        dur="3.375s"
        repeatCount="indefinite"
        keyTimes="0;1"
        keySplines=".65 0 .35 1"
        calcMode="spline"
      />
      <animateTransform
        id="init_2"
        attributeType="XML"
        attributeName="transform"
        type="scale"
        xlinkHref="#c_1"
        values="0 0; 1.25 1.25"
        begin="init.begin; last.end+0.375s"
        dur="1.5s"
        keyTimes="0;1"
        keySplines=".68 .31 .83 .67"
        calcMode="spline"
        fill="freeze"
      />
      <animateTransform
        id="init_3"
        attributeType="XML"
        attributeName="transform"
        type="scale"
        xlinkHref="#c_2"
        values="0 0; 1.25 1.25"
        begin="init_2.begin+0.375s"
        dur="1.5s"
        keyTimes="0;1"
        keySplines=".68 .31 .83 .67"
        calcMode="spline"
        fill="freeze"
      />
      <animateTransform
        id="init_4"
        attributeType="XML"
        attributeName="transform"
        type="scale"
        xlinkHref="#c_3"
        values="0 0; 1.25 1.25"
        begin="init_3.begin+0.375s"
        dur="1.5s"
        keyTimes="0;1"
        keySplines=".68 .31 .83 .67"
        calcMode="spline"
        fill="freeze"
      />
      <animateTransform
        id="init_5"
        attributeType="XML"
        attributeName="transform"
        type="scale"
        xlinkHref="#c_4"
        values="0 0; 1.25 1.25"
        begin="init_4.begin+0.375s"
        dur="1.5s"
        keyTimes="0;1"
        keySplines=".68 .31 .83 .67"
        calcMode="spline"
        fill="freeze"
      />
      <animateTransform
        id="last"
        attributeType="XML"
        attributeName="transform"
        type="scale"
        xlinkHref="#c_5"
        values="0 0; 1.25 1.25"
        begin="init_5.begin+0.375s"
        dur="1.5s"
        keyTimes="0;1"
        keySplines=".68 .31 .83 .67"
        calcMode="spline"
        fill="freeze"
      />
      <animateTransform
        id="reset"
        attributeType="XML"
        attributeName="transform"
        type="scale"
        xlinkHref="#c_1"
        values="1.25 1.25; 0 0"
        begin="last.end"
        dur="0.01s"
        keyTimes="0;1"
        keySplines=".68 .31 .83 .67"
        calcMode="spline"
        fill="freeze"
      />
      <animateTransform
        attributeType="XML"
        attributeName="transform"
        type="scale"
        xlinkHref="#c_2"
        values="1.25 1.25; 0 0"
        begin="reset.begin+0.02s"
        dur="0.01s"
        keyTimes="0;1"
        keySplines=".68 .31 .83 .67"
        calcMode="spline"
        fill="freeze"
      />
      <animateTransform
        attributeType="XML"
        attributeName="transform"
        type="scale"
        xlinkHref="#c_3"
        values="1.25 1.25; 0 0"
        begin="reset.begin+0.03s"
        dur="0.01s"
        keyTimes="0;1"
        keySplines=".68 .31 .83 .67"
        calcMode="spline"
        fill="freeze"
      />
      <animateTransform
        attributeType="XML"
        attributeName="transform"
        type="scale"
        xlinkHref="#c_4"
        values="1.25 1.25; 0 0"
        begin="reset.begin+0.04s"
        dur="0.01s"
        keyTimes="0;1"
        keySplines=".68 .31 .83 .67"
        calcMode="spline"
        fill="freeze"
      />
      <animateTransform
        attributeType="XML"
        attributeName="transform"
        type="scale"
        xlinkHref="#c_5"
        values="1.25 1.25; 0 0"
        begin="reset.begin+0.05s"
        dur="0.01s"
        keyTimes="0;1"
        keySplines=".68 .31 .83 .67"
        calcMode="spline"
        fill="freeze"
      />
    </svg>
  );
}

export default AnimatingHead;
